import { render } from "./ContentHorizontalLayout.vue?vue&type=template&id=186e4cf6&ts=true"
import script from "./ContentHorizontalLayout.vue?vue&type=script&lang=ts"
export * from "./ContentHorizontalLayout.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__